export default {
    navigation: {
        krok: {
            title: "Step",
            description: "Training on STEPs"
        },
    },
    loginKrok: {
        title: "Login to ePlato Step",
        code: "Quiz code",
        button: "Start quiz",
        link: "Login to ePlato"
    },
    login: {
        title: "Login to ePlato",
        login: "Username",
        password: "Password",
        button: "Log-in",
        linkQuiz: "KROK-quiz"
    },
    studentQuiz: {
        remaining: "Remaining",
        automaticSwitch: "Switch questions automatically",
        questionNo: "Question #",
        previousQuestion: "Previous question",
        nextQuestion: "Next question",
        answeredQuestion: "This question was already answered",
        finishQuiz: "Finish quiz",
        quizIsFinished: "Quiz is finished",
        logoutFromSystem: "Log-out from quiz"
    },
    studentKrok: {
        electronicRegister: "Electronic register",
        spaTraining: "Training on SPA",
        ktiTraining: "Training on (KROK) KTI",
        spaSubjects: "SPA Subjects",
        topics: "Topics",
        selectSubject: "Select subject",
        selectTopic: "Select topic",
        questionsCount: "Questions count for quiz",
        startQuiz: "Start quiz",
        problematicQuestions: "Problematic questions",
        attempt: "Attempt",
        from: "з",
        attemptsOnPage: "Attempts on page",
        all: "All",
        continue: "Continue",
        start: "Start",
        finish: "Finish",
        questionCount: "Question count",
        questionCorrectCount: "Correct question count",
        questionCorrectPercentage: "% of correct count",
        actions: "Actions",
        noData: "No data",
        errorCount: "Errors count:",
        close: "Close",
        noProblematicQuestions: "No problematic questions at the moment",
        withProblematicQuestions: "Include problematic questions",
    }
}